import * as React from 'react';
import { memo } from 'react';

import { CardProps } from 'components/molecules/Card';
import FigureIcon from 'components/molecules/Card/Fragments/FigureIcon';
import PreviewImage from 'components/molecules/Card/Fragments/PreviewImage';
import ThirdPartyLogo from 'components/molecules/Card/Fragments/ThirdPartyLogo';
import SVGCardFigureLine from 'components/molecules/Card/svg/card-figure-line';
import SVGCardTrackingIcon from 'components/molecules/Card/svg/card-tracking-icon';
import { CardTypes } from 'defs/card-types';
import { CardTypeTypes } from 'types/Card';

type CardHeaderPropsType = {
	type: CardTypeTypes;
	uiState?: string;
	preselectedCustomWorkoutPreviewImage?: any; // Image?
	previewImage?: any; // Image?
	customWorkoutPreviewImage?: any; // Image?
	thirdPartyLogo?: any; // Image?
	categoryIcon: string;
};

const CardHeader = (props: CardProps | (CardHeaderPropsType & any)) => {
	return (
		<div className="m-card__head">
			{props.type !== CardTypes.Tracking && (
				<div className="m-card__image">
					{props.type === CardTypes.Workout && (
						<PreviewImage
							type={props.type}
							previewImage={
								props.uiState === 'detail'
									? props.preselectedCustomWorkoutPreviewImage || props.previewImage
									: props.customWorkoutPreviewImage || props.previewImage
							}
						/>
					)}
					{props.type !== CardTypes.Workout && (
						<PreviewImage type={props.type} previewImage={props.previewImage} />
					)}
				</div>
			)}
			<ThirdPartyLogo thirdPartyLogo={props.thirdPartyLogo} />
			<div className="m-card__figure">
				<SVGCardFigureLine />
				{props.type === CardTypes.Tracking && <SVGCardTrackingIcon />}
				<FigureIcon categoryIcon={props.categoryIcon} />
			</div>
		</div>
	);
};

CardHeader.displayName = 'Card(Header)';

export default memo(CardHeader);
